/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import { Box, Group, ScrollArea, Stack, Text } from '@mantine/core';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useCurrentUser from '../../../hooks/useCurrentUser';
import { LocalStorageKey } from '../../../utils/constants.utils';
import Brand from './Brand/Brand';
import DataReferenceLinks from './DataReferenceLinks/DataReferenceLinks';
import DefaultLinks from './DefaultLinks/DefaultLinks';
import ManagerialLinks from './ManagerialLinks/ManagerialLinks';

function NavBar() {
  const navigate = useNavigate();
  const [currentUser] = useCurrentUser();

  useEffect(() => {
    const currentAppVersion = process.env.REACT_APP_VERSION!;
    let localAppVersion = localStorage.getItem(LocalStorageKey.ApplicationVersion);

    if (!localAppVersion) {
      localAppVersion = '0.0.0';
    }

    if (Number(localAppVersion.replaceAll('.', '')) < Number(currentAppVersion.replaceAll('.', ''))) {
      localStorage.setItem(LocalStorageKey.ApplicationVersion, currentAppVersion);
      navigate('/logout', {
        replace: true,
      });
    }
  }, []);

  return (
    <ScrollArea type="hover" scrollHideDelay={0} scrollbarSize={4}>
      <Group grow>
        <Brand />
      </Group>
      <Group grow>
        <Box py="sm">
          <DefaultLinks visible={currentUser.gerencial} userPermissions={currentUser.permissoes} />
          <DataReferenceLinks userPermissions={currentUser.permissoes} />
          <ManagerialLinks visible={currentUser.gerencial} />
        </Box>
      </Group>
      <Stack mt={25} align="center" gap={3}>
        <Text c="dimmed" size="xs" align="center">
          Performa Manager © {new Date().getFullYear()}
        </Text>
        <Text c="dimmed" size="xs" align="center">
          Version {process.env.REACT_APP_VERSION}
        </Text>
      </Stack>
    </ScrollArea>
  );
}

export default NavBar;
